var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center py-5"},[_vm._v(" "+_vm._s(_vm.lang('Processing...'))+" "),(_vm.state.loading)?_c('loader'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }